import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import styled from '@emotion/styled';
import axios from 'axios';
import { CircularProgress } from '@mui/material';

type MarkdownPreviewProps = {
  url: string;
};

const MarkdownPreview: React.FC<MarkdownPreviewProps> = ({ url }) => {
  const [markdownContent, setMarkdownContent] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const fetchMarkdown = async () => {
    try {
      setError(null);
      const response = await axios.get(url, { responseType: 'text' });
      setMarkdownContent(response.data);
    } catch (err) {
      console.error(err);
      setError('Error fetching data');
    }
  };

  useEffect(() => {
    fetchMarkdown();
  }, [url]);

  return (
    <Container>
      {error ? (
        <ErrorMessage>{error}</ErrorMessage>
      ) : markdownContent ? (
        <ReactMarkdown>{markdownContent}</ReactMarkdown>
      ) : (
        <Loader />
      )}
    </Container>
  );
};

export default MarkdownPreview;

const Container = styled.div`
  width: 100%;
  max-height: 50vh;
  overflow-y: auto;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 4px;
  padding: 16px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  font-family: ${({ theme }) => theme.typography.fontFamily};

  &::-webkit-scrollbar-corner {
    background: transparent;
  }
`;

const Loader = styled(CircularProgress)`
  display: block;
  margin: 0 auto;
`;

const ErrorMessage = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.palette.error.main};
  font-size: 1rem;
  padding: 20px;
`;